import { FilterFormData } from 'app/components/FilterPanel/FilterPanel';
import { initialValuesRawI } from 'app/hooks/useGetInitialFilterValues';
export interface FormEquality {
  fleetOnly: boolean;
  fleetGroup: boolean;
  status: boolean;
  country: boolean;
  source: boolean;
  type: boolean;
  inPortKey: boolean;
  inAreaCode: boolean;
  destinationPortKey: boolean;
  constructionDate: boolean;
  eta: boolean;
  sog: boolean;
  cog: boolean;
  heading: boolean;
  draught: boolean;
}

export const getVesselsFilterFormEquality = (initialValuesRaw: initialValuesRawI, formDataRaw: FilterFormData): FormEquality => {
  const formEquality = {
    fleetOnly: formDataRaw.fleetOnly === initialValuesRaw.fleetOnly,
    fleetGroup: formDataRaw.fleetGroupAll === initialValuesRaw.fleetGroupAll,
    status: formDataRaw.statusAll === initialValuesRaw.statusAll,
    country: formDataRaw.countryAll === initialValuesRaw.countryAll,
    source: formDataRaw.sourceAll === initialValuesRaw.sourceAll,
    type: formDataRaw.typeAll === initialValuesRaw.typeAll,
    inPortKey: formDataRaw.inPortKey?.length === 0 && !formDataRaw.selectedInPort,
    inAreaCode: formDataRaw.inAreaCode?.length === 0 && !formDataRaw.selectedInArea,
    destinationPortKey: formDataRaw.destinationPortKey?.length === 0 && !formDataRaw.selectedDestinationPort,
    constructionDate:
      (formDataRaw.constructionDate_from === initialValuesRaw.constructionDate_from ||
        formDataRaw.constructionDate_from === '') &&
      (formDataRaw.constructionDate_to === initialValuesRaw.constructionDate_to || formDataRaw.constructionDate_to === ''),

    eta:
      (formDataRaw.eta_from === initialValuesRaw.eta_from || formDataRaw.eta_from === '') &&
      (formDataRaw.eta_to === initialValuesRaw.eta_to || formDataRaw.eta_to === ''),
    sog:
      (formDataRaw.sog_min === initialValuesRaw.sog_min || formDataRaw.sog_min === '') &&
      (formDataRaw.sog_max === initialValuesRaw.sog_max || formDataRaw.sog_max === ''),
    cog:
      (formDataRaw.cog_min === initialValuesRaw.cog_min || formDataRaw.cog_min === '') &&
      (formDataRaw.cog_max === initialValuesRaw.cog_max || formDataRaw.cog_max === ''),
    heading:
      (formDataRaw.heading_min === initialValuesRaw.heading_min || formDataRaw.heading_min === '') &&
      (formDataRaw.heading_max === initialValuesRaw.heading_max || formDataRaw.heading_max === ''),
    draught:
      (formDataRaw.draught_min === initialValuesRaw.draught_min || formDataRaw.draught_min === '') &&
      (formDataRaw.draught_max === initialValuesRaw.draught_max || formDataRaw.draught_max === ''),
  };
  return formEquality;
};
